import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { setAdminToken } from '../utils/adminAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

interface AdminLoginProps {
  onLogin: () => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || 'Login failed');
        return;
      }

      setAdminToken(data.data.token);
      setPassword('');
      onLogin();
    } catch {
      setError('Could not connect to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="p-8 rounded-lg border" style={{ backgroundColor: '#1a1a1a', borderColor: '#39ff14' }}>
        <div className="text-center mb-6">
          <Lock className="h-12 w-12 mx-auto mb-3" style={{ color: '#39ff14' }} />
          <h1 className="text-2xl font-bold tracking-wider" style={{ color: '#39ff14', fontFamily: "'911 Porscha', sans-serif", fontStyle: 'italic' }}>
            ADMIN LOGIN
          </h1>
          <p className="text-sm mt-2" style={{ color: '#a0a0a0' }}>
            Authorized access only
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="admin-password" className="block text-sm font-medium mb-1" style={{ color: '#e0e0e0' }}>
              Password
            </label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:border-transparent"
              style={{ backgroundColor: '#0f0f0f', borderColor: '#39ff14', color: '#e0e0e0' }}
              required
              disabled={loading}
            />
          </div>

          {error && (
            <p className="text-sm text-red-400">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full px-4 py-2 rounded-md font-bold transition-colors disabled:opacity-50"
            style={{ backgroundColor: '#39ff14', color: '#0a0a0a' }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
